import { api, BaseAPI } from '@services/api';

class API extends BaseAPI {
  constructor() {
    super('localization/unit');
  }
  getUnitDivisions = async (unit_id: number) => {
    return api.get(this.buildUrl('unit_divisions'), {
      params: { unit_id: unit_id },
      paramsSerializer: {
        indexes: null,
      },
    });
  };
}

export default new API();
